import React from "react";
import {Route} from "react-router-dom";
import MarketDistri from "./distri";
import MarketPrizeUnlock from "./prizeunlock";
import GroupBuy from "./groupbuy";
import VerifierRouter from "./verifier";
import Batchdeliver from "./batchdeliver/batchdeliver";
import FormRouter from "./form";
import RedeemCodeRouter from "./redeemcode";
import PubSub from "pubsub-js";
import Utils from "../public/utils";
import noPermissions from "../config/noPermissions/noPermissions";
import {connect} from "react-redux";

/**
 * @author Yaochao
 * @date 2021/7/15 16:20
 * @description
 */

class Market extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                {
                    this.props.subInfo.isSub == 0 ?
                        <>
                            <Route path={this.props.match.url + "/distri"} component={MarketDistri}/>
                            <Route path={this.props.match.url + "/prizeunlock"} component={MarketPrizeUnlock}/>
                            <Route path={this.props.match.url + "/groupbuy"} component={GroupBuy}/>
                            <Route path={this.props.match.url + "/redeemcode"} component={RedeemCodeRouter}/>
                            <Route path={this.props.match.url + "/verifier"} component={VerifierRouter}/>
                            <Route path={this.props.match.url + "/batchdeliver"} component={Batchdeliver}/>
                            <Route path={this.props.match.url + "/form"} component={FormRouter}/>
                        </> : this.props.subInfo.isSub == 1 ?
                        <>
                            <Route path={this.props.match.url + "/distri"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_distri') ?
                                       MarketDistri : noPermissions}/>
                            <Route path={this.props.match.url + "/prizeunlock"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_prizeunlock') ?
                                       MarketPrizeUnlock : noPermissions}/>
                            <Route path={this.props.match.url + "/groupbuy"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_groupbuy') ?
                                       GroupBuy : noPermissions}/>
                            <Route path={this.props.match.url + "/redeemcode"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_redeemcode') ?
                                       RedeemCodeRouter : noPermissions}/>
                            <Route path={this.props.match.url + "/verifier"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_verifier') ?
                                       VerifierRouter : noPermissions}/>
                            <Route path={this.props.match.url + "/batchdeliver"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_batchdeliver') ?
                                       Batchdeliver : noPermissions}/>
                            <Route path={this.props.match.url + "/form"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'market','market_from') ?
                                       FormRouter : noPermissions}/>
                        </> : <></>
                }

            </>
        )
    }
}

export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo: subReducer
    }
})(Market)